module.exports = __webpack_public_path__ + "static/img/home.08a9b363.png";